// src/components/Calendar/YearPicker.tsx

import type React from "react";
import { yearsAroundRange } from "./utils";

interface YearPickerProps {
  currentYear: number;
  onSelect: (year: number) => void;
}

export function YearPicker({ currentYear, onSelect }: YearPickerProps) {
  const years = yearsAroundRange(currentYear - 10, currentYear + 10);
  return (
    <div style={listStyle}>
      {years.map((y) => {
        const isCurrent = y === currentYear;
        return (
          <button
            type="button"
            key={y}
            onClick={() => onSelect(y)}
            style={{
              ...btnStyle,
              background: isCurrent ? "#263238" : "transparent",
              color: isCurrent ? "#ffffff" : "#0E1A1A",
              fontWeight: isCurrent ? 700 : 500,
            }}
            onMouseEnter={(e) => { if (!isCurrent) (e.currentTarget as HTMLElement).style.background = "#F3F5F5"; }}
            onMouseLeave={(e) => { if (!isCurrent) (e.currentTarget as HTMLElement).style.background = "transparent"; }}
          >
            {y}
          </button>
        );
      })}
    </div>
  );
}

const listStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  maxHeight: 240,
  overflowY: "auto",
  padding: 4,
};

const btnStyle: React.CSSProperties = {
  padding: "8px 12px",
  textAlign: "left",
  fontSize: 13,
  cursor: "pointer",
  borderRadius: 6,
  border: 0,
  fontFamily: "inherit",
};